import React from 'react'
import { Card, Button, Divider, Grid, Dialog, TextField, AppBar, IconButton, Avatar } from '@material-ui/core'
import { Block, CardGiftcardSharp, Close, ExpandLess, Face, FavoriteOutlined, Group, Info, KeyboardSharp, MonetizationOn, MonetizationOnOutlined, Money, NotificationImportant } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import ReactTimeago from 'react-timeago';
import ReactMarkdown from 'react-markdown';

const GENDER = ["Male", "Female"]
export default function Stats({ api, data }) {
    const history = useHistory();
    const [username, setUsername] = React.useState('')
    const [notice, setNotice] = React.useState('')
    const [showUserDialog, setShowUserDialog] = React.useState(false)
    const [userData, setUserData] = React.useState(null)
    const [sendNotificationDialog, setSendNotification] = React.useState(false);
    const parse=(data,key)=>{
        
        switch(typeof data){
            case 'boolean':
                    return data?'yes':'no';
            case 'object':
                return JSON.stringify(data)
            case 'number':
                    if(data>9999999) return new Date(data).toString()
                    else return data;
            default:
                return data;

        }
    }
    return (
        <div style={{ marginLeft: 4 }}>
            <Dialog fullScreen={true} open={sendNotificationDialog}>
                <AppBar style={{ padding: 10, flexDirection: 'row', alignItems: 'center' }}>
                    <h3 style={{ flex: 1 }}>Send Notifications</h3>
                    <IconButton color="inherit" onClick={e => setSendNotification(false)}><Close /></IconButton>
                </AppBar>
                <div style={{ marginTop: 80, padding: 5 }}>
                    <ReactMarkdown source={notice} />
                    <hr />
                    <br />
                    <TextField multiline={true} rows="12" placeholder="enter notice in markdown" fullWidth value={notice} onChange={e => setNotice(e.target.value)} />
                    <br />
                    <br />
                    <Button onClick={e => {
                        api.axios.post("/send-notification", { notice })
                            .then(d => {

                                api.showSnack('Notification sent successfully.', 'success')
                                setSendNotification(false)
                                setNotice('')
                            })
                            .catch(e => api.showSnack(e.error || 'Something went wrong', 'error'))
                    }} variant="outlined" color="primary" >Send Notification</Button>
                </div>


            </Dialog>

            <Dialog fullScreen={true} open={showUserDialog} >
                <AppBar style={{ padding: 10, flexDirection: 'row', alignItems: 'center' }}>
                    <h3 style={{ flex: 1 }}>Users</h3>
                    <IconButton color="inherit" onClick={e => setShowUserDialog(false)}><Close /></IconButton>
                </AppBar>
                <div style={{ marginTop: 80, padding: 5 }}>
                    <TextField value={username} onChange={e => setUsername(e.target.value)} label="Enter username" fullWidth />
                    <br />
                    <br />
                    <Button disabled={username.trim().length === 0} onClick={e => {
                        api.axios.get("users/" + username)
                            .then(d => setUserData(d))
                            .catch(e => api.showSnack(e.error || 'Something went wrong.', 'error'))
                    }} variant="outlined" color="primary">Search</Button>
                    <br />
                    <br />
                    <Divider />
                    {userData ?
                        <div style={{ backgroundColor: '#43A047', color: 'white', padding: 10, margin: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Avatar src={userData.image}></Avatar>
                            <br />
                                {Object.keys(userData).map(d=><div style={{marginTop:5}}>
                                    {d} : <b>{parse(userData[d],d)}</b>
                                    </div>)}
                             </div>
                        : <Card style={{ padding: 15, margin: 15 }}>
                            When you search a user it will be shown here !
                        </Card>}

                </div>
            </Dialog>
            <h3>Stats</h3>
            <br />
            <Grid container style={{ display: 'flex', margin: 5 }}>
            <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Group />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.usersCount}</h3>
                        <h5>Users</h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Group />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.onlineCount}</h3>
                        <h5>Online Users</h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <MonetizationOn />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.credits}</h3>
                        <h5>Credits </h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Info />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.reports}</h3>
                        <h5>Reports </h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Group />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.merchants}</h3>
                        <h5>Merchants </h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Block />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.banned}</h3>
                        <h5>Banned Users </h5>
                    </div>
                </Card>
                <Card style={{ padding: 10, margin: 10, textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                    <Group />
                    <div style={{ marginLeft: 10, marginRight: 5 }}>
                        <h3>{data.rooms}</h3>
                        <h5>Rooms</h5>
                    </div>
                </Card>
            </Grid>
            <Divider />
            <h3>Menus</h3>
            <br />
            <Grid container style={{ display: 'flex' }} >
                <Card onClick={e => history.push("/dash/keys")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <KeyboardSharp />
                    <h3>Keys</h3>
                </Card>
                <Card onClick={e => history.push("/dash/gifts")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CardGiftcardSharp />
                    <h3>Gifts</h3>
                </Card>
                <Card onClick={e => setShowUserDialog(true)} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Group />
                    <h3>Users</h3>
                </Card>
                <Card onClick={e => history.push("/dash/avatars")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Face />
                    <h3>Avatars</h3>
                </Card>
                <Card onClick={e => history.push("/dash/leaderboard")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <ExpandLess />
                    <h3>Leaderboard</h3>
                </Card>
                <Card onClick={e => history.push("/dash/send-credit")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <MonetizationOnOutlined />
                    <h3>Send Credit</h3>
                </Card>
                <Card onClick={e => {
                    setSendNotification(true)

                }} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <NotificationImportant />
                    <h3>Send Notification</h3>
                </Card>
                <Card onClick={e => history.push("/dash/rewards")} style={{ padding: 15, margin: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <FavoriteOutlined />
                    <h3>Rewards</h3>
                </Card>

            </Grid>
            <br />
            <h3>Recent 15 Transactions</h3>
            {data.transactions && data.transactions.map(t => <Card style={{ margin: 9, padding: 8 }}>
                {t.from} gave {t.to} {t.amount} nekos Reason: {t.remarks}.

            </Card>)}
            <br />
            <h3>Top Rooms</h3>
            {data.topRooms && data.topRooms.map(t => <Card style={{ margin: 9, padding: 8 }}>
                Admin Username: {t.admin.username} -  Name: {t.name} - Participants: {t.participants}
            </Card>)}
            {data.others && data.others.map(s => <div>
                <h3>{s.type}</h3>
                {s.data && s.data.map(t => <Card style={{ margin: 9, padding: 8 }}>
                    Username: {t.username} - Email: {t.email} - Name: {t.name} - Credit: {t.credit} - Gender: {GENDER[t.gender]}
                </Card>)}
            </div>)}
        </div >
    )
}
